function SentinelViewButtons($timeout, $rootScope, filterService, sentinelService, sentinelSearchCriteriaFactory) {
    return {
        redirect: 'E',
        replace: true,
        scope: {
            currentView: "="
        },
		template: require('./view-buttons.html'),

        link: function (scope) {
            scope.displayOptions = filterService.getMasterDisplayOptions();
            scope.userHasWrite = ($rootScope.selectedLog.role !== 'READ');

            scope.showCreateVisitModal = function () {
                $('#create-visit-modal').modal({backdrop: 'static', keyboard: false}, 'show');
                $rootScope.$broadcast('sentinel-show-create-modal');
            };

            scope.toggleActiveOnly = function () {
                scope.displayOptions.showActiveOnly = !scope.displayOptions.showActiveOnly;
                filterService.setMasterDisplayOptions(scope.displayOptions);
            };

            scope.toggleComments = function () {
                scope.displayOptions.showComments = !scope.displayOptions.showComments;
                filterService.setMasterDisplayOptions(scope.displayOptions);

                var searchCriteria = sentinelSearchCriteriaFactory.get();
                searchCriteria.showComments = scope.displayOptions.showComments;
                sentinelSearchCriteriaFactory.set(searchCriteria);

                if (scope.displayOptions.showComments) {
                    $('.collapse.panel-collapse').collapse('show');
                } else {
                    $('.collapse.panel-collapse').collapse('hide');
                }
            };

            scope.toggleSummaryReport = function() {
                scope.displayOptions.summaryReport = !scope.displayOptions.summaryReport;
                filterService.setMasterDisplayOptions(scope.displayOptions);
            };

            scope.toggleShowCards = function() {
                scope.displayOptions.showCards = !scope.displayOptions.showCards;
                filterService.setMasterDisplayOptions(scope.displayOptions);
            };

            scope.filterFacility = function() {
                var newlySelectedFacility = scope.selectedFacility === 'All' ? '' : scope.selectedFacility;
                $rootScope.$broadcast("selected-facility-changed", {selectedFacility: newlySelectedFacility});
                // If selectedFacility isn't "All"
                if (scope.selectedFacility && scope.selectedFacility !== 'All') {
                    // If localStorage item already exists
                    if (localStorage.getItem("sentinelFacility")) {
                        var facilityStorageArray = JSON.parse(localStorage.getItem("sentinelFacility"));
                        for (var i = 0; i < facilityStorageArray.length; i++) {
                            // If item already exists for current user and log
                            if (facilityStorageArray[i].userId === $rootScope.user.id && facilityStorageArray[i].logId === $rootScope.selectedLog.id) {
                                facilityStorageArray[i].selectedFacility = newlySelectedFacility;
                            }
                            // If item doesn't exist for current user and log
                            else if (i === facilityStorageArray.length - 1 ) {
                                facilityStorageArray.push({
                                    userId: $rootScope.user.id,
                                    logId: $rootScope.selectedLog.id,
                                    selectedFacility: newlySelectedFacility
                                });
                            }
                        }
                        if (facilityStorageArray.length === 0) { localStorage.removeItem("sentinelFacility"); }
                        else { localStorage.setItem("sentinelFacility", JSON.stringify(facilityStorageArray)); }
                    // If localStorage item doesn't exist
                    } else {
                        localStorage.setItem("sentinelFacility", JSON.stringify([{
                            userId: $rootScope.user.id,
                            logId: $rootScope.selectedLog.id,
                            selectedFacility: newlySelectedFacility
                        }]));
                    }
                    sentinelService.setFacilityFilter(newlySelectedFacility);
                // If selectedFacility is 'All'
                } else {
                    // If localStorage item already exists
                    if (localStorage.getItem("sentinelFacility")) {
                        var facilityStorageArray = JSON.parse(localStorage.getItem("sentinelFacility"));
                        for (var i = 0; i < facilityStorageArray.length; i++) {
                            // If item already exists for current user and log
                            if (facilityStorageArray[i].userId === $rootScope.user.id && facilityStorageArray[i].logId === $rootScope.selectedLog.id) {
                                facilityStorageArray.splice(i, 1);
                                if (facilityStorageArray.length === 0) { localStorage.removeItem("sentinelFacility"); }
                                else { localStorage.setItem("sentinelFacility", JSON.stringify(facilityStorageArray)); }
                            }
                        }
                    }
                    sentinelService.setFacilityFilter('');
                }
            };

            scope.print = function() {
                window.print();
            };

            scope.exportExcel = function() {
                $rootScope.$broadcast("exportExcel");
            };

            scope.$watch(function () {
                return $rootScope.selectedLog;
            }, function () {
                if ($rootScope.selectedLog) {
                    sentinelService.getFacilitiesList($rootScope.selectedLog.id).then(function (facilities) {
                        scope.availableFacilities = facilities;
                        if (scope.availableFacilities && scope.availableFacilities.length > 1) scope.availableFacilities.unshift("All");
                        else scope.selectedFacility = scope.availableFacilities[0];

                        if (localStorage.getItem("sentinelFacility")) {
                            var facilityStorageArray = JSON.parse(localStorage.getItem("sentinelFacility"));
                            for (var i = 0; i < facilityStorageArray.length; i++) {
                                if (facilityStorageArray[i].userId === $rootScope.user.id && facilityStorageArray[i].logId === $rootScope.selectedLog.id) {
                                    scope.selectedFacility = facilityStorageArray[i].selectedFacility;
                                    break;
                                }
                                else if (i === facilityStorageArray.length - 1) {
                                    scope.selectedFacility = 'All';
                                }
                            }
                        } else {
                            if (!scope.availableFacilities) return;
                            scope.selectedFacility = scope.availableFacilities.length > 1 ? 'All' : scope.availableFacilities[0];
                        }
                        if (scope.selectedFacility === null) scope.selectedFacility = scope.availableFacilities ? scope.availableFacilities[0] : 'All';
                        sentinelService.setFacilityFilter(scope.selectedFacility === 'All' ? '' : scope.selectedFacility);
                    });
                }
            });
        }
    }
}

angular.module('sentinel').directive('sentinelViewButtons', ['$timeout', '$rootScope', 'sentinelUiFilterService', 'sentinelService', 'sentinelSearchCriteriaFactory', SentinelViewButtons]);